import * as CONSTRUCTOR from '../../generate';

export const unitReservationRefundResponse = CONSTRUCTOR.FRAGMENT({
  name: 'UnitReservationRefund',
  fragmentName: 'UnitReservationRefundFields',
  fields: `{
    id
    opportunity_id
    amount_minor
    currency_code
    reason
    bank_name
    bank_account_number
    bank_account_name
    project_name
    purchaser_name
    rejection_reason
    status
    created_at
    updated_at
  }`,
});

export const listUnitReservationRefundsResponse = CONSTRUCTOR.FRAGMENT({
  name: 'ListUnitReservationRefundsResponse',
  fragmentName: 'ListUnitReservationRefundsResponseFields',
  fields: `{
    refunds {
      id
      opportunity_id
      amount_minor
      currency_code
      reason
      bank_name
      bank_account_number
      bank_account_name
      project_name
      purchaser_name
      rejection_reason
      status
      created_at
      updated_at
    }
    total_count
  }`,
});
